<template>
  <div>
    <template v-if="!showErrors">
      <div class="scrollable-list">
        <div class="list-header font-weight-bold">
          <span>{{ title }}</span>
        </div>
        <div class="list-body">
          <!-- works with typeof array_of_objects -->
          <ul class="list-unstyled p-0 m-0">
            <li v-for="(item, index) in successList" :key="index">
              <span
                ><b>{{ $t('common.product') }}</b></span
              >
              <span>{{ ': ' + item.productName }}</span>
            </li>
          </ul>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="scrollable-list">
        <div class="list-header font-weight-bold">
          <span>{{ title }}</span>
        </div>
        <div class="list-body">
          <!-- works with typeof array_of_objects -->
          <div v-if="arrErrorList.length > 0">
            <ul class="list-unstyled m-0 p-0">
              <li class="mb-2 pb-1 border-bottom" v-for="(error, index) in arrErrorList" :key="index">
                <span v-if="error.row">{{ $t('pit.pitRow') + ': ' + error.row }} | </span>
                <span v-if="error.column">{{ $t('pit.pitColumn') + ': ' + error.column }} | </span>
                <span v-if="error.error">{{ $t('pit.pitError') + ': ' + error.error }} </span>
              </li>
            </ul>
          </div>
          <!-- works with typeof object_grouped (see reducer in parent view) -->
          <div v-if="objectKeysErrorList.length > 0">
            <ul class="list-unstyled mb-2 p-0 border-bottom" v-for="(item, index) in objectKeysErrorList" :key="index">
              <li class="mb-1">
                <div class="d-block">
                  <span
                    ><b>{{ $t('common.product') }}</b></span
                  >
                  <span>{{ ': ' + item }}</span>
                </div>
                <div class="d-block" v-for="(error, index) in objErrorList[item]" :key="index">
                  <span v-if="error.row">{{ $t('pit.pitRow') + ': ' + error.row }} | </span>
                  <span v-if="error.column">{{ $t('pit.pitColumn') + ': ' + error.column }} | </span>
                  <span v-if="error.error">{{ $t('pit.pitError') + ': ' + error.error }} </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    showErrors: {
      type: Boolean,
      default: false,
    },
    successList: Array,
    arrErrorList: Array,
    objErrorList: Object,
  },
  computed: {
    objectKeysErrorList() {
      return Object.keys(this.objErrorList)
    },
  },
}
</script>

<style lang="scss" scoped>
.scrollable-list {
  height: 276px;
  overflow: auto;
  border: 1px solid var(--gray8);
  border-radius: 0.5rem;
}
.scrollable-list > .list-header {
  padding: 0.5rem;
  background-color: var(--secondaryBGColor);
}
.scrollable-list > .list-body {
  padding: 0.5rem;
}
</style>
